/**
 * Optimized Shopify Header Behavior Script
 * Reusable & Performance-tuned for Shopify Sections (v2.3 - Full Dawn Polish)
 */
window.initCustomHeader = function(sectionId) {
  const header = document.getElementById(sectionId);
  if (!header) return;

  const navItems = header.querySelectorAll('.cmh__nav-item');
  const navInner = header.querySelector('.cmh__nav-inner');
  const navList = header.querySelector('.cmh__nav-list');

  const openSearchButtons = header.querySelectorAll('.cmh__open-search');
  const desktopSearchInput = header.querySelector('.cmh__search-trigger-input');
  const desktopSearchForm = header.querySelector('.cmh__search-trigger-form');
  const desktopPredictive = header.querySelector('.cmh__predictive-search--desktop');
  const mobileSearchInput = header.querySelector('.cmh__mobile-search-trigger-input');
  const mobileSearchForm = header.querySelector('.cmh__mobile-search-trigger-form');
  const mobilePredictive = header.querySelector('.cmh__predictive-search--mobile');
  const mobileSearchOverlay = document.querySelector('.cmh__mobile-search-overlay');
  const mobileOverlayInput = mobileSearchOverlay ? mobileSearchOverlay.querySelector('.cmh__mobile-overlay-search-input') : null;
  const mobileOverlayPredictive = mobileSearchOverlay ? mobileSearchOverlay.querySelector('.cmh__predictive-search--mobile-overlay') : null;
  const mobileOverlayClose = mobileSearchOverlay ? mobileSearchOverlay.querySelector('.cmh__mobile-search-overlay-close') : null;

  function normalizeUrl(url) {
    if (!url) return '';
    try {
      const parsedUrl = new URL(url, window.location.origin);
      let pathname = parsedUrl.pathname;
      if (pathname.length > 1) {
        pathname = pathname.replace(/\/+$/, '');
      }
      return pathname || '/';
    } catch (error) {
      return url.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';
    }
  }

  function setActiveMobileNav() {
    const currentPath = normalizeUrl(window.location.href);
    navItems.forEach(function (item) {
      const linkUrl = item.getAttribute('href');
      if (!linkUrl || linkUrl === '#') {
        item.classList.remove('is-active');
        return;
      }
      item.classList.toggle('is-active', normalizeUrl(linkUrl) === currentPath);
    });
  }

  function checkNavOverflow() {
    if (!navInner || !navList) return;
    navInner.classList.toggle('cmh-nav-overflow', navList.scrollWidth > navInner.clientWidth + 1);
  }

  setActiveMobileNav();
  checkNavOverflow();

  let activeNavResizeTimer;
  let resizeTimer;

  window.addEventListener('resize', function () {
    clearTimeout(activeNavResizeTimer);
    clearTimeout(resizeTimer);
    activeNavResizeTimer = setTimeout(setActiveMobileNav, 150);
    resizeTimer = setTimeout(checkNavOverflow, 150);
  }, { passive: true });

  if (window.ResizeObserver && navInner && navList) {
    const observer = new ResizeObserver(function () {
      requestAnimationFrame(checkNavOverflow);
    });
    observer.observe(navInner);
    observer.observe(navList);
  }

  function setPlaceholderState(input) {
    if (!input) return;
    const form = input.closest('.cmh__search');
    if (!form) return;
    form.classList.toggle('has-value', input.value.trim().length > 0);
  }

  function setPredictiveState(input, predictive) {
    if (!predictive || !input) return;
    const hasValue = input.value.trim().length > 0;
    predictive.classList.toggle('is-active', hasValue);
    if (!hasValue) {
      predictive.removeAttribute('open');
    }
  }

  function focusSearchInput(input) {
    if (!input) return;
    try {
      input.focus({ preventScroll: true });
    } catch (error) {
      input.focus();
    }
    try {
      const length = input.value.length;
      input.setSelectionRange(length, length);
    } catch (error) {}
  }

  function syncSearchValue(sourceInput) {
    if (!sourceInput) return;
    const value = sourceInput.value;

    if (desktopSearchInput && desktopSearchInput !== sourceInput) {
      desktopSearchInput.value = value;
      setPlaceholderState(desktopSearchInput);
      setPredictiveState(desktopSearchInput, desktopPredictive);
    }

    if (mobileSearchInput && mobileSearchInput !== sourceInput) {
      mobileSearchInput.value = value;
      setPlaceholderState(mobileSearchInput);
      setPredictiveState(mobileSearchInput, mobilePredictive);
    }
  }

  function openMobileSearchOverlay() {
    if (!mobileSearchOverlay || window.innerWidth > 749) return;
    mobileSearchOverlay.classList.add('is-open');
    mobileSearchOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cmh-mobile-search-open');
    if (mobileOverlayInput) {
      mobileOverlayInput.value = '';
      setPlaceholderState(mobileOverlayInput);
      initTypewriterPlaceholder(mobileOverlayInput);
      setTimeout(function () { focusSearchInput(mobileOverlayInput); }, 80);
    }
  }

  function closeMobileSearchOverlay() {
    if (!mobileSearchOverlay) return;
    if (mobileOverlayInput) {
      mobileOverlayInput.value = '';
      setPlaceholderState(mobileOverlayInput);
      try { mobileOverlayInput.blur(); } catch (error) {}
    }
    clearPredictiveResults(mobileOverlayPredictive);
    mobileSearchOverlay.classList.remove('is-open');
    mobileSearchOverlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cmh-mobile-search-open');
  }

  openSearchButtons.forEach(function (button) {
    button.removeAttribute('aria-haspopup');
    button.addEventListener('click', function (event) {
      event.preventDefault();
      if (window.innerWidth <= 749) {
        if (mobileSearchInput && mobileSearchInput.offsetParent !== null) {
          focusSearchInput(mobileSearchInput);
        } else {
          openMobileSearchOverlay();
        }
        return;
      }
      focusSearchInput(desktopSearchInput);
    });
  });

  function handleEmptySearchSubmit(event, form) {
    const input = form && form.querySelector('input[name="q"]');
    if (!input) return;
    if (!input.value.trim()) {
      event.preventDefault();
      focusSearchInput(input);
    }
  }

  if (desktopSearchForm) {
    desktopSearchForm.addEventListener('submit', function (event) {
      handleEmptySearchSubmit(event, desktopSearchForm);
    });
  }

  if (mobileSearchForm) {
    mobileSearchForm.addEventListener('submit', function (event) {
      handleEmptySearchSubmit(event, mobileSearchForm);
    });
  }

  const predictiveControllers = new WeakMap();
  const predictiveTimers = new WeakMap();
  const predictiveCache = new Map();

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getPredictiveResultsElement(predictive) {
    return predictive ? predictive.querySelector('[data-predictive-search]') : null;
  }

  function ensurePredictiveCloseButton(predictive, input) {
    if (!predictive) return null;
    let closeButton = predictive.querySelector('.cmh__predictive-close');
    if (closeButton) return closeButton;

    closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'cmh__predictive-close';
    closeButton.setAttribute('aria-label', 'Close search suggestions');
    closeButton.setAttribute('title', 'Close');
    closeButton.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '</svg>';

    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (input) {
        input.value = '';
        setPlaceholderState(input);
        syncSearchValue(input);
        const form = input.closest('.cmh__search');
        if (form) form.classList.remove('is-focused', 'has-value');
        initTypewriterPlaceholder(input);
        try { input.blur(); } catch (error) {}
      }
      clearPredictiveResults(predictive);
    });

    predictive.appendChild(closeButton);
    return closeButton;
  }

  function initTypewriterPlaceholder(input) {
    if (!input) return;
    const form = input.closest('.cmh__search');
    if (!form) return;
    const placeholder = form.querySelector('.cmh__search-placeholder');
    const highlight = placeholder ? placeholder.querySelector('.cmh__search-highlight') : null;
    if (!highlight) return;

    const words = ['Facewash', 'Trimmer', 'Razor', 'Skincare'];
    if (input._cmhTypewriterTimer) {
      clearTimeout(input._cmhTypewriterTimer);
    }

    let wordIndex = 0;
    let characterIndex = 0;
    let deleting = false;
    highlight.textContent = '';

    function typeNext() {
      if (input.value.trim() || document.activeElement === input) {
        input._cmhTypewriterTimer = null;
        return;
      }
      const word = words[wordIndex];
      if (!deleting) {
        characterIndex += 1;
        highlight.textContent = word.slice(0, characterIndex);
        if (characterIndex >= word.length) {
          deleting = true;
          input._cmhTypewriterTimer = setTimeout(typeNext, 1400);
          return;
        }
        input._cmhTypewriterTimer = setTimeout(typeNext, 85);
        return;
      }
      characterIndex -= 1;
      highlight.textContent = word.slice(0, characterIndex);
      if (characterIndex <= 0) {
        deleting = false;
        wordIndex = (wordIndex + 1) % words.length;
        input._cmhTypewriterTimer = setTimeout(typeNext, 300);
        return;
      }
      input._cmhTypewriterTimer = setTimeout(typeNext, 50);
    }
    typeNext();
  }

  function getProductImage(product) {
    if (!product || !product.featured_image) return '';
    return typeof product.featured_image === 'string'
      ? product.featured_image
      : product.featured_image.url || '';
  }

  function renderPredictiveProducts(predictive, products, query) {
    const results = getPredictiveResultsElement(predictive);
    if (!results) return;

    if (!products || !products.length) {
      results.innerHTML = '<div class="cmh__custom-predictive-message">No products found for “' + escapeHtml(query) + '”.</div>';
      return;
    }

    const items = products.slice(0, 8).map(function (product) {
      const title = escapeHtml(product.title || 'Product');
      const url = escapeHtml(product.url || '#');
      const image = getProductImage(product);
      const imageHtml = image
        ? '<img class="cmh__custom-predictive-image" src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy" decoding="async">'
        : '<span class="cmh__custom-predictive-image" aria-hidden="true"></span>';

      let price = product.price != null && product.price !== '' ? product.price : product.price_min;
      price = escapeHtml(price || '');

      return (
        '<a class="cmh__custom-predictive-item" href="' + url + '">' +
          imageHtml +
          '<span class="cmh__custom-predictive-info">' +
            '<span class="cmh__custom-predictive-title">' + title + '</span>' +
            (price ? '<span class="cmh__custom-predictive-price">' + price + '</span>' : '') +
          '</span>' +
          '<span class="cmh__custom-predictive-arrow" aria-hidden="true">→</span>' +
        '</a>'
      );
    }).join('');

    results.innerHTML = '<div class="cmh__custom-predictive-list" role="listbox">' + items + '</div>';
  }

  function showPredictiveLoading(predictive) {
    const results = getPredictiveResultsElement(predictive);
    if (results) {
      results.innerHTML = '<div class="cmh__custom-predictive-loading">Searching products…</div>';
    }
  }

  function clearPredictiveResults(predictive) {
    const results = getPredictiveResultsElement(predictive);
    if (results) results.innerHTML = '';
    if (predictive) {
      predictive.classList.remove('is-active');
      predictive.removeAttribute('open');
    }
  }

  function fetchPredictiveProducts(input, predictive) {
    if (!input || !predictive) return;
    const query = input.value.trim();
    if (!query) {
      clearPredictiveResults(predictive);
      return;
    }

    const cachedProducts = predictiveCache.get(query);
    if (cachedProducts) {
      renderPredictiveProducts(predictive, cachedProducts, query);
      ensurePredictiveCloseButton(predictive, input);
      predictive.classList.add('is-active');
      return;
    }

    ensurePredictiveCloseButton(predictive, input);
    predictive.classList.add('is-active');
    showPredictiveLoading(predictive);

    const previousController = predictiveControllers.get(predictive);
    if (previousController) previousController.abort();

    const controller = new AbortController();
    predictiveControllers.set(predictive, controller);

    const params = new URLSearchParams({
      'q': query,
      'resources[type]': 'product',
      'resources[limit]': '8',
      'resources[options][unavailable_products]': 'hide'
    });

    fetch('/search/suggest.json?' + params.toString(), {
      credentials: 'same-origin',
      signal: controller.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Predictive search request failed: ' + response.status);
        return response.json();
      })
      .then(function (data) {
        if (controller.signal.aborted) return;
        const products = data?.resources?.results?.products || [];
        predictiveCache.set(query, products);

        if (predictiveCache.size > 20) {
          const firstKey = predictiveCache.keys().next().value;
          predictiveCache.delete(firstKey);
        }

        renderPredictiveProducts(predictive, products, query);
        ensurePredictiveCloseButton(predictive, input);
        predictive.classList.add('is-active');
      })
      .catch(function (error) {
        if (error?.name === 'AbortError') return;
        const results = getPredictiveResultsElement(predictive);
        if (results) {
          results.innerHTML = '<div class="cmh__custom-predictive-message">Unable to load suggestions. Please try again.</div>';
        }
        predictive.classList.add('is-active');
      });
  }

  function schedulePredictiveSearch(input, predictive) {
    if (!input || !predictive) return;
    const oldTimer = predictiveTimers.get(predictive);
    if (oldTimer) clearTimeout(oldTimer);

    if (!input.value.trim()) {
      clearPredictiveResults(predictive);
      return;
    }

    const timer = setTimeout(function () {
      fetchPredictiveProducts(input, predictive);
    }, 180);
    predictiveTimers.set(predictive, timer);
  }

  function handleSearchInput(input, predictive) {
    setPlaceholderState(input);
    syncSearchValue(input);
    setPredictiveState(input, predictive);
    schedulePredictiveSearch(input, predictive);
  }

  function bindSearchInput(input, predictive) {
    if (!input) return;
    const form = input.closest('.cmh__search');
    setPlaceholderState(input);
    initTypewriterPlaceholder(input);
    ensurePredictiveCloseButton(predictive, input);

    input.addEventListener('mousedown', () => form?.classList.add('is-focused'));
    input.addEventListener('touchstart', () => form?.classList.add('is-focused'), { passive: true });
    
    input.addEventListener('focus', () => {
      form?.classList.add('is-focused');
      setPlaceholderState(input);
      const placeholder = form?.querySelector('.cmh__search-placeholder');
      if (placeholder) placeholder.style.opacity = '0';
      if (input.value.trim() && predictive) schedulePredictiveSearch(input, predictive);
    });

    input.addEventListener('blur', () => {
      if (form && !input.value.trim()) {
        form.classList.remove('is-focused');
        const placeholder = form.querySelector('.cmh__search-placeholder');
        if (placeholder) placeholder.style.opacity = '1';
        initTypewriterPlaceholder(input);
      }
    });

    input.addEventListener('input', () => {
      form?.classList.toggle('is-focused', input.value.trim().length > 0 || document.activeElement === input);
      handleSearchInput(input, predictive);
    });
    input.addEventListener('change', () => handleSearchInput(input, predictive));
    input.addEventListener('search', () => handleSearchInput(input, predictive));
  }

  bindSearchInput(desktopSearchInput, desktopPredictive);
  bindSearchInput(mobileSearchInput, mobilePredictive);
  bindSearchInput(mobileOverlayInput, mobileOverlayPredictive);

  if (mobileOverlayClose) {
    mobileOverlayClose.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeMobileSearchOverlay();
    });
  }

  const accountLink = header.querySelector('[data-account-link]');
  if (accountLink) {
    accountLink.removeAttribute('aria-haspopup');
    accountLink.removeAttribute('aria-expanded');
    accountLink.removeAttribute('aria-controls');
    accountLink.addEventListener('click', function (event) {
      if (accountLink.dataset.customerLoggedIn === 'true') {
        event.stopPropagation();
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (header.contains(event.target)) return;
    clearPredictiveResults(desktopPredictive);
    clearPredictiveResults(mobilePredictive);
  }, { passive: true });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (mobileSearchOverlay && mobileSearchOverlay.classList.contains('is-open')) {
      closeMobileSearchOverlay();
      return;
    }
    if (document.activeElement === desktopSearchInput || document.activeElement === mobileSearchInput) {
      document.activeElement.blur();
    }
  });

  // --- Dawn-Style Sticky Scroll & Dynamic Trigger Spacer ---
  const topHeader = header.querySelector('.cmh__top');
  if (topHeader) {
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const delta = 4;
    let ticking = false;

    // Create hidden spacer initially (prevents load gap/CLS)
    const spacer = document.createElement('div');
    spacer.className = 'cmh__top-permanent-spacer';
    spacer.style.width = '100%';
    spacer.style.display = 'none';
    spacer.style.height = '0px';
    topHeader.parentNode.insertBefore(spacer, topHeader);

    let headerInitialOffset = topHeader.getBoundingClientRect().top + window.pageYOffset;

    window.addEventListener('resize', function() {
      if (!topHeader.classList.contains('cmh-top-fixed')) {
        headerInitialOffset = topHeader.getBoundingClientRect().top + window.pageYOffset;
      } else {
        spacer.style.height = topHeader.offsetHeight + 'px';
      }
    }, { passive: true });

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          let st = window.pageYOffset || document.documentElement.scrollTop;
          if (st < 0) st = 0;

          // When scrolled back up past the original position, unfix and hide spacer
          if (st <= headerInitialOffset) {
            topHeader.classList.remove('cmh-top-fixed', 'cmh-top-hidden');
            topHeader.style.transform = 'translateY(0)';
            spacer.style.display = 'none';
            spacer.style.height = '0px';
            lastScrollTop = st;
            ticking = false;
            return;
          }

          // Exact moment it hits the top: lock it and assign spacer height
          if (!topHeader.classList.contains('cmh-top-fixed')) {
            spacer.style.height = topHeader.offsetHeight + 'px';
            spacer.style.display = 'block';
            topHeader.classList.add('cmh-top-fixed');
          }

          // Handle hide/show sliding logic on scroll direction change
          if (Math.abs(lastScrollTop - st) > delta) {
            if (st > lastScrollTop && st > headerInitialOffset + topHeader.offsetHeight + 20) {
              topHeader.classList.add('cmh-top-hidden');
              topHeader.style.transform = 'translateY(-100%)';
            } else if (st < lastScrollTop) {
              topHeader.classList.remove('cmh-top-hidden');
              topHeader.style.transform = 'translateY(0)';
            }
            lastScrollTop = st;
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }
};